import { drawShapes, drawSingle as _drawSingle, updateShapesPanZoom, updateActiveShapes as _updateActiveShapes, updateAndDrawShapes } from "../../shared/render/shapes";

import { a } from "../../shared/globalState/a";
import { t as _t } from "../../shared/globalState/t";
import { g } from "../../shared/globalState/g";

import { mat3 } from "gl-matrix";
import { clearTooltipAll } from "../../services/tooltip";


function handleSpacebarDown() {
    // убрать марки если начинается режим панорамы
    clearTooltipAll();
    // перерисовать фигуры чтобы убрать области выбора элементов boundary
    drawShapes();
    a.pan = true;
    a.isPanning = true;
}
function handleSpacebarUp() {
    a.pan = false;
    g.context.uniformMatrix3fv(g.u_pan, false, mat3.create());
    updateShapesPanZoom('pan');



    a.pan_tx = 0;
    a.pan_ty = 0;
    // проверить какие фигуры находятся в области полотна
    updateAndDrawShapes();


}


let spacebarPressed = false;


function registerSpacebarEvents() {
    document.addEventListener('keydown', (ev) => {
        if (ev.key === ' ' && !spacebarPressed) {
            handleSpacebarDown();
            spacebarPressed = true;
            
        }
    });
    
    document.addEventListener('keyup', (ev) => {
        if (ev.key === ' ') {
            handleSpacebarUp();
            spacebarPressed = false;
        }
    });
}

export { handleSpacebarDown, handleSpacebarUp, registerSpacebarEvents }